function incrementValue(e) {
  e.preventDefault();
  var id = $(e.target).data('field'); 
  var currentVal = parseInt($('#product-'+id).val(),10);
  
  $('#product-'+id).attr("value", currentVal+1);
  
  if(currentVal+1 === 1){
    $("#button-minus-"+id).attr('disabled','disabled');
  }
  else{
    $("#button-minus-"+id).removeAttr('disabled');
  }
  
  var maxVal = $('#product-'+id).attr('max');
  if(maxVal < currentVal+1){
    $('.add-'+id).attr('disabled','disabled');
    $('.buy-it-now-'+id).attr('disabled','disabled');
  }
}

function decrementValue(e) {
  e.preventDefault();
  var id = $(e.target).data('field'); 
  var currentVal = parseInt($('#product-'+id).val(),10);
  if(currentVal > 1){
    var newValue = currentVal - 1
    $('#product-'+id).attr("value", currentVal-1);
  }

  if(currentVal-1 === 1){
    $("#button-minus-"+id).attr('disabled','disabled');
  }
  else{
    $("#button-minus-"+id).removeAttr('disabled');
  }

  var maxVal = $('#product-'+id).attr('max');
  if(maxVal < currentVal-1){
    $('.add-'+id).attr('disabled','disabled');
    $('.buy-it-now-'+id).attr('disabled','disabled');
  }
  else{
    if($('#product-'+id).val() > 0){
      $('.add-'+id).removeAttr('disabled');
      $('.buy-it-now-'+id).removeAttr('disabled');
    }
    
  }
}
